import BaseApi from "./BaseApi";
import { ApiPaths } from './ApiPaths';

const create = () => {
    const api = BaseApi.create({
        errorCodes: [403, 404]
    });

    const getConversation = (userId, userType, product, offset) => api.get(ApiPaths.GET_CONVERSATION(userId, userType, product, offset));
    const createConversation = (payload) => api.post(ApiPaths.CONVERSATIONS, payload);
    const createConversationTag = (payload) => api.post(ApiPaths.CONVERSATION_TAGS, payload);
    const getMemberships = (conversationId) => api.get(ApiPaths.GET_MEMBERBSHIPS_BY_CONVERSATION_ID(conversationId));
    const createMembership = (payload) => api.post(ApiPaths.CONVERSATION_MEMBERSHIPS, payload);
    const getMessages = (conversationId, offset, limit) => api.get(ApiPaths.GET_MESSAGES(conversationId, offset, limit));
    const createMessage = (payload) => api.post(ApiPaths.MESSAGES, payload);
    const getUnreadMessagesCount = (conversationId) => api.get(ApiPaths.GET_UNREAD_MESSAGES(conversationId));
    const markMessagesRead = (maxMessageId) => api.post(ApiPaths.MARK_MESSAGE_READ(maxMessageId), '');
    return {
        getConversation,
        createConversation,
        createConversationTag,
        getMemberships,
        createMembership,
        getMessages,
        createMessage,
        getUnreadMessagesCount,
        markMessagesRead,
    };
};

export default {
    create
};